import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'maintenance-alert',
    templateUrl: './maintenance-alert.component.html',
    styleUrls: ['./maintenance-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaintenanceAlertComponent implements OnInit, OnDestroy {
  @Input() layout: 'login' | 'home' = 'home';
  @Input() dismissible = false;

  visible = true;
  maintenanceStarted = false;
  days = 0;
  hours = '00';
  minutes = '00';
  seconds = '00';

  private readonly maintenanceStart = new Date('2026-08-08T01:00:00-05:00').getTime();
  private countdownTimer: ReturnType<typeof setInterval>;

  ngOnInit(): void {
    this.updateCountdown();
    this.countdownTimer = setInterval(() => this.updateCountdown(), 1000);
  }

  ngOnDestroy(): void {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }

  close(): void {
    this.visible = false;
  }

  private updateCountdown(): void {
    const timeRemaining = this.maintenanceStart - Date.now();

    if (timeRemaining <= 0) {
      this.maintenanceStarted = true;
      return;
    }

    this.days = Math.floor(timeRemaining / 86400000);
    this.hours = this.pad(Math.floor((timeRemaining % 86400000) / 3600000));
    this.minutes = this.pad(Math.floor((timeRemaining % 3600000) / 60000));
    this.seconds = this.pad(Math.floor((timeRemaining % 60000) / 1000));
  }

  private pad(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
